import { useTranslation } from 'react-i18next'
import { useUpdateTourMutation } from '@/entities/tour'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface TourStatusToggleProps {
  tourId: string
  isActive: boolean
}

export function TourStatusToggle({ tourId, isActive }: TourStatusToggleProps) {
  const { t } = useTranslation()
  const updateMutation = useUpdateTourMutation()

  async function handleConfirmed() {
    try {
      await updateMutation.mutateAsync({
        id: tourId,
        payload: { isActive: !isActive },
      })
      showToast.success(t('tour.statusUpdateSuccess'))
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={updateMutation.isPending}
        confirmEnableTitle={t('tour.restoreConfirm')}
        confirmDisableTitle={t('tour.deactivateConfirm', { defaultValue: 'Deactivate this tour?' })}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
